import React from 'react';
import '../styles/AboutMe.css';
import profileImage from '../assets/img/my-pic.jpeg';
import { useLanguage } from "../helpers/LanguageContext";
import { translations } from "../helpers/translations";

const AboutMe = () => {
    const { language } = useLanguage();
    const t = translations[language].aboutMe;

    return (
        <div className="about-container">
            <div className="about-inner">
                <img src={profileImage} alt="Antonio Fiocco" className="about-photo" />
                <h1>{t.title}</h1>
                <p>
                    {t.p1}
                    <br /><br />
                    {t.p2}
                    <br /><br />
                    {t.p3}
                    <br /><br />
                    {t.p4}
                    <br /><br />
                    {t.p5}
                    <br /><br />
                    {t.p6}
                </p>
            </div>
        </div>
    );
};

export default AboutMe;
